export class MapContentStyle {
  marginTop = 'uk-margin-top';
  dropCap = '';
  size = 'uk-h5';
  font = 'tb-font-primary';

  static normalize(listStyles: Partial<MapContentStyle>): MapContentStyle {
    const pureListStyle = new MapContentStyle();

    pureListStyle.marginTop = listStyles.marginTop ?? pureListStyle.marginTop;
    pureListStyle.dropCap = listStyles.dropCap ?? pureListStyle.dropCap;
    pureListStyle.size = listStyles.size ?? pureListStyle.size;
    pureListStyle.font = listStyles.font ?? pureListStyle.font;

    return pureListStyle;
  }
}
